export default __webpack_public_path__ + "static/media/p42.108fe120.jpg";